<template>
  <v-layout
    wrap
  >
    <v-flex
      xs12
      md6
    >
      <v-text-field
        v-model.trim.number="form.minWithdrawal"
        :error-messages="MinWithdrawalErrors"
        name="min-withdrawal"
        :label="$t('whitelabel.minWithdrawal')"
        suffix="USDT"
        @input="$v.form.minWithdrawal.$touch()"
        @blur="$v.form.minWithdrawal.$touch()"
        @keypress="onlyForCurrency($event, form.minWithdrawal)"
      />
    </v-flex>
    <v-flex
      xs12
      md6
    >
      <v-text-field
        v-model.trim.number="form.maxWithdrawal"
        :error-messages="MaxWithdrawalErrors"
        name="max-withdrawal"
        :label="$t('whitelabel.maxWithdrawal')"
        suffix="USDT"
        @input="$v.form.maxWithdrawal.$touch()"
        @blur="$v.form.maxWithdrawal.$touch()"
        @keypress="onlyForCurrency($event, form.maxWithdrawal)"
      />
    </v-flex>
  </v-layout>
</template>

<script>
import { validationMixin } from "vuelidate";
import {
  minValue,
  maxValue,
} from "vuelidate/lib/validators";



export default {
  name: "WhiteLabelSettings",
  mixins: [validationMixin],
  props: {
    editForm: {
      type: Object,
      default: null
    },
  },
  data() {
    return {
      form: {
        minWithdrawal: 1,
        maxWithdrawal: 1,
      }
    };
  },
  computed: {
    rules() {
      var form = {
        minWithdrawal: {
          minValue: minValue(1),
          maxValue: maxValue(50000)
        },
        maxWithdrawal: {
          minValue: minValue(1),
          maxValue: maxValue(50000)
        },
      };
      return form;
    },
    MinWithdrawalErrors() {
      const errors = [];
      if (!this.$v.form.minWithdrawal.$dirty) return errors;
      !this.$v.form.minWithdrawal.minValue &&
        errors.push(this.$t("whitelabel.minValueError", {char: this.$v.form.minWithdrawal.$params.minValue.min}));
      !this.$v.form.minWithdrawal.maxValue &&
        errors.push(this.$t("whitelabel.maxValueError", {char: this.$v.form.minWithdrawal.$params.maxValue.max}));
      return errors;
    },
    MaxWithdrawalErrors() {
      const errors = [];
      if (!this.$v.form.maxWithdrawal.$dirty) return errors;
      !this.$v.form.maxWithdrawal.minValue &&
        errors.push(this.$t("whitelabel.minValueError", {char: this.$v.form.maxWithdrawal.$params.minValue.min}));
      !this.$v.form.maxWithdrawal.maxValue &&
        errors.push(this.$t("whitelabel.maxValueError", {char: this.$v.form.maxWithdrawal.$params.maxValue.max}));
      return errors;
    },
  },
  watch: {
    editForm(value) {
      if (value && value.settings) {
        this.form = {
          minWithdrawal: value.settings.min_withdrawal_amount || 1,
          maxWithdrawal: value.settings.max_withdrawal_amount || 1,
        }
      }
    },
    "form.minWithdrawal" : {
      handler(value) {
        if(this.form.maxWithdrawal < value) {
          this.form.maxWithdrawal = value;
        }
      },
      deep: true,
      immediate: true,
    },
  },
  validations() {
    return {
      form: this.rules
    };
  },
  methods: {
    save() {
      if(this.form.minWithdrawal === 1 && this.form.maxWithdrawal === 1) {
        this.$emit('saveForm', {});
      } else {
        this.$v.$touch();
        if (!this.$v.$invalid) {
          const form  = {
            settings: {
              min_withdrawal_amount: this.form.minWithdrawal,
              max_withdrawal_amount: this.form.maxWithdrawal
            }
          }
          this.$emit('saveForm', form);
        }
      }
    },
  }
};
</script>

<style lang="scss">

</style>